import { render } from "./AdminCrmConnections.vue?vue&type=template&id=c6848642&scoped=true"
import script from "./AdminCrmConnections.vue?vue&type=script&lang=js"
export * from "./AdminCrmConnections.vue?vue&type=script&lang=js"

import "./AdminCrmConnections.vue?vue&type=style&index=0&id=c6848642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6848642"]])

export default __exports__